import type { InferOutput, flatten as vFlatten } from 'valibot';
import {
  object as vObject,
  picklist as vPickList,
  nonEmpty as vNonEmpty,
  string as vString,
  pipe as vPipe,
  check as vCheck,
  trim as vTrim,
  email as vEmail,
  optional as vOptional,
  boolean as vBoolean,
} from 'valibot';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { LanguageSchema } from '@@/shared/application';
import { AddressRetrieveSchema } from '@@/shared/address/types';
import { MarketingTrackingSchema } from '#shared/lead/marketing';

type ContactProjectType = InferOutput<typeof ContactProjectTypeSchema>;
const ContactProjectTypeSchema = vPickList([
  'buy',
  'sell',
  'rent',
]);
export const CONTACT_PROJECT_TYPE_VALUES: Array<ContactProjectType> = [`buy`, `sell`, `rent`] as const;

export type ContactLeadInfo = InferOutput<typeof ContactLeadInfoSchema>;
export const ContactLeadInfoSchema = vObject({
  firstName: vPipe(
    vString(),
    vTrim(),
    vNonEmpty('core.form.error.mandatory_field'),
  ),
  lastName: vPipe(
    vString(),
    vTrim(),
    vNonEmpty('core.form.error.mandatory_field'),
  ),
  email: vPipe(
    vString(),
    vNonEmpty('core.form.error.mandatory_field'),
    vEmail('agent.form.error.email'),
  ),
  phone: vPipe(
    vString(),
    vTrim(),
    vNonEmpty('core.form.error.mandatory_field'),
    vCheck(input => isValidPhoneNumber(input), 'agent.form.error.phone'),
  ),
  message: vOptional(vPipe(
    vString(),
    vTrim(),
  )),
  adSubscription: vOptional(vBoolean()),
  adPartnerSubscription: vOptional(vBoolean()),
});

export type ContactForm = InferOutput<typeof ContactFormSchema>;
export type ContactFormIssues = ReturnType<typeof vFlatten<typeof ContactFormSchema>>;
export const ContactFormSchema = vObject({
  project: ContactProjectTypeSchema,
  locale: LanguageSchema,
  ...ContactLeadInfoSchema.entries,
});
export type ContactFormBody = InferOutput<typeof ContactFormBodySchema>;
export const ContactFormBodySchema = vObject({
  contactForm: ContactFormSchema,
  marketingTracking: vOptional(MarketingTrackingSchema),
});

export type ContactSellerForm = InferOutput<typeof ContactSellerFormSchema>;
export type ContactSellerFormIssues = ReturnType<typeof vFlatten<typeof ContactSellerFormSchema>>;
export const ContactSellerFormSchema = vObject({
  ...ContactFormSchema.entries,
  address: AddressRetrieveSchema,
});
export type ContactSellerBody = InferOutput<typeof ContactSellerBodySchema>;
export const ContactSellerBodySchema = vObject({
  contactForm: ContactSellerFormSchema,
  marketingTracking: vOptional(MarketingTrackingSchema),
});
